Service = App.loadClass 'core::Angular/Service'

class exports.Machinery extends Service
    constructor: (@resource, @http, @rootScope) ->
        @Machinery = @resource 'backend/grower/machinery/:type/:id', { id: '@id' },
            update: method: 'PUT'
        @Type = @resource 'backend/grower/machinery/types/:id'
        @Subtype = @resource 'backend/grower/machinery/types/:typeId/subtypes/:id'
        @Make = @resource 'backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/:id', null,
            validateUniqueName:
                method: 'POST'
                url: 'backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/validate-unique-name'
        @Model = @resource 'backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/:makeId/models/:id', null,
            validateUniqueName:
                method: 'POST'
                url: 'backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/:makeId/models/validate-unique-name'

        @ControllerMake = @resource 'backend/grower/machinery/controller-makes/:id'
        @ControllerModel = @resource 'backend/grower/machinery/controller-makes/:makeId/controller-models/:id'
        @RxNamingFormat = @resource 'backend/grower/machinery/controller-makes/:makeId/controller-models/:modelId/rx-naming-format/:id'
        @RowSpacing = @resource 'backend/grower/machinery/row-spacings/:id', null,
            validateWidth:
                method: 'POST'
                url: 'backend/grower/machinery/row-spacings/validate-width'

    __unNest = (machine) ->
        # if machine.model?
            # machine.make = machine.model?.make
            # machine.subtype = machine.make?.subtype
            # machine.type = machine.subtype?.type
        machine.controller_make = machine.controller_model?.make
        return machine

    __reNest = (machine) ->
        # if machine.model?
            # machine.subtype.type = machine.type
            # machine.make.subtype = machine.subtype
            # machine.model.make = machine.make
        machine.controller_model?.make = machine.controller_make
        return machine

    __typeToRoute = (type) ->
        # Because silly farmers
        if type.name is 'Tillage'
            return 'tillers'
        else
            return type.name.toLowerCase() + 's'

    getMachinery: (type, id = null) ->
        typeName = __typeToRoute type
        if id?
            @Machinery.get
                type: typeName
                id: id
            .$promise.then __unNest
        else
            @Machinery.query
                type: typeName
            .$promise.then (machinery) ->
                __unNest machine for machine in machinery
                return machinery

    # Loading Machinery
    getTypes: () ->
        @Type.query()
        .$promise

    getType: (id) ->
        @Type.get { id }
        .$promise

    getSubtypes: (type) ->
        @Subtype.query
            typeId: type.id
        .$promise

    getSubtype: (type, id) ->
        @Subtype.get
            typeId: type.id
            id: id
        .$promise

    getMakes: (type, subtype) ->
        @Make.query
            typeId: type.id
            subtypeId: subtype.id
        .$promise

    getMake: (type, subtype, id) ->
        @Make.get
            typeId: type.id
            subtypeId: subtype.id
            id: id
        .$promise

    getModels: (type, subtype, make) ->
        @Model.query
            typeId: type.id
            subtypeId: subtype.id
            makeId: make.id
        .$promise

    getModel: (type, subtype, make, id) ->
        @Model.get
            typeId: type.id
            subtypeId: subtype.id
            makeId: make.id
            id: id
        .$promise

    getControllerMakes: () ->
        @ControllerMake.query()
        .$promise

    getControllerMake: (id) ->
        @ControllerMake.get { id }
        .$promise

    getControllerModels: (make) ->
        @ControllerModel.query
            makeId: make.id
            hasFormats: true
        .$promise

    getControllerModel: (make, id) ->
        @ControllerModel.get
            makeId: make.id
            id: id
        .$promise

    getProprietaryFormats: (make, model) ->
        @RxNamingFormat.query
            makeId: make.id
            modelId: model.id
        .$promise

    getProprietaryFormat: (make, model, id) ->
        @RxNamingFormat.get
            makeId: make.id
            modelId: model.id
            id: id
        .$promise

    getFormData: (machinery) ->
        return @getMachinery machinery.type, 'form'

    getPermissions: () ->
        return @http.get 'backend/grower/machinery/permissions'
            .then (result) ->
                return result.data

    new: (data) ->
        return new @Machinery data

    # Save Machinery
    save: (machinery) ->
        type = __typeToRoute machinery.type
        __reNest(machinery)
        if machinery.id?
            return machinery.$update { type, id: machinery.id }
                .then __unNest
        return machinery.$save { type }
            .then __unNest

    delete: (machinery) ->
        type = __typeToRoute machinery.type
        return machinery.$delete { type }

    saveMake: (make) ->
        return make.$save
            typeId: make.subtype.type.id
            subtypeId: make.subtype.id

    saveModel: (model) ->
        return model.$save
            typeId: model.make.subtype.type.id
            subtypeId: model.make.subtype.id
            makeId: model.make.id

    requestController: (make, model) ->
        return @http.post 'backend/grower/machinery/request-controller',
            make: make.name
            model: model.name
        .then (result) ->
            return result.data

    createRowSpacing: (rowSpacing) ->
        return rowSpacing.$save()

    # Validation
    validateNickname: (machine, name) ->
        return @http.post 'backend/grower/machinery/validate-nickname',
            nickname: name
            type: machine.type.name
            id: machine.id

    validateMake: (type, subtype, name) ->
        return @Make.validateUniqueName
            typeId: type.id
            subtypeId: subtype.id
        , { name }
        .$promise

    validateModel: (type, subtype, make, name) ->
        return @Model.validateUniqueName
            typeId: type.id
            subtypeId: subtype.id
            makeId: make.id
        , { name }
        .$promise

    validateRowSpacing: (width) ->
        return @RowSpacing.validateWidth { width }
        .$promise
